import * as React from 'react';
import { IInputProps } from './IInput';
import ToolTip from '../ToolTip/ToolTip';
import { Placement } from '../ToolTip/IToolTip';

const Input = (props: IInputProps) => {
    return (
        <div className={props.className} style={{ ...props.styleDiv }}>
            <label htmlFor={props.name}>{props.title}</label>
            {props.withInfo && (
                <ToolTip title={props.infoTitle} placement={Placement.top} withHtml={props.withHtmlInfo}>
                    <i className='fa-sharp fa-solid fa-circle-info fs-5 p-2 align-self-end' />
                </ToolTip>
            )}
            <input
                type={props.type}
                id={props.name}
                name={props.name}
                min={props.min}
                max={props.max}
                className={props.classNameInput}
                style={{ ...props.styleInput }}
                placeholder={props.placeholder}
                required={props.required}
                value={props.value}
                defaultValue={props.defaultValue}
                step={props.step}
                readOnly={props.readonly}
                disabled={props.disabled}
                onChange={props.onChange}></input>
        </div>
    );
};

export default Input;
